export const FORM_COMPLETE = '/';
export const CHOOSE_SITE = '/alege-site';
export const CHOOSE_LANGUAGE = '/alege-limba';
export const CHOOSE_MARKETING = '/alege-marketing';
export const CHOOSE_MAINTENANCE = '/alege-mentenanta';
export const CHOOSE_HOSTING = '/alege-hosting';
export const CHOOSE_PACK = '/alege-pachet';
export const MODIFY_PACK = '/modifica-pachet';
export const COMMENTS = '/comentarii';
